import { useState, useEffect } from 'react';
import ReactMultiSelectCheckboxes from 'react-multiselect-checkboxes';

const ProvinceSelector = (props) => {

    const [selectedOptions, setSelectedOptions] = useState([]);
    const [allOptions, setAllOptions] = useState([]);

    useEffect(() => {
        setSelectedOptions([{ label: "กรุงเทพมหานคร", value: "กรุงเทพมหานคร" }]);
        if(props.view === 1){
          setAllOptions([{ label: "ทั้งประเทศ", value: "ทั้งประเทศ" }, ...props.provinceSelectorObj]);
        } else if (props.view === 4){
          setAllOptions([{ label: "ทั้งประเทศ", value: "All" }, ...props.provinceSelectorObj]);
        } else {
          setAllOptions([...props.provinceSelectorObj]);
        }
      }, []);

    props.onChange(selectedOptions);

    function getDropdownButtonLabel({ placeholderButtonLabel, value }) {
        return `${placeholderButtonLabel}: เลือก ${value.length} `;
      }
    
    function onChange(value, event) {
        if (value.length === this.input_length - 1) {
            this.setState(this.props.provinceSelectorObj);
        } else {
            this.setState(value);
        }
    }

      return (
        <ReactMultiSelectCheckboxes
          options={allOptions}
          placeholderButtonLabel="จังหวัด"
          getDropdownButtonLabel={getDropdownButtonLabel}
          value={selectedOptions}
          onChange={onChange}
          setState={setSelectedOptions}
        />
      );

}
 
export default ProvinceSelector;

